if (!customElements.get('arome-delivery-estimate')) {
  customElements.define('arome-delivery-estimate', class extends HTMLElement {
    static get observedAttributes() {
      return ['data-available'];
    }

    connectedCallback() {
      if (!this.dataset.noDateLinkBound) {
        this.dataset.noDateLinkBound = 'true';
        this.addEventListener('click', (event) => {
          const link = event.target?.closest?.('a');
          if (link && this.contains(link)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, true);
      }
      this.render();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-available' && oldValue !== newValue && this.isConnected) this.render();
    }

    render() {
      const locale = document.documentElement.lang || 'es-MX';
      const available = String(this.dataset.available) !== 'false';
      const startDays = Number(this.dataset.startDays || 3);
      const endDays = Number(this.dataset.endDays || 5);
      const start = new Date();
      const end = new Date();
      start.setDate(start.getDate() + startDays);
      end.setDate(end.getDate() + endDays);

      const day = new Intl.DateTimeFormat(locale, { day: 'numeric' });
      const month = new Intl.DateTimeFormat(locale, { month: 'long' });
      const target = this.querySelector('[data-delivery-dates]');
      const status = this.querySelector('[data-delivery-stock]');
      const prefix = this.querySelector('[data-delivery-prefix]');

      this.classList.toggle('is-unavailable', !available);

      if (!available) {
        if (status) status.textContent = 'Presentación agotada';
        if (prefix) prefix.textContent = 'Selecciona otra presentación disponible';
        if (target) {
          target.textContent = '';
          target.hidden = true;
        }
        return;
      }

      if (status) status.textContent = 'En stock · listo para enviar';
      if (prefix) prefix.textContent = 'Llega entre';

      if (target) {
        target.hidden = false;
        const startDay = day.format(start);
        const endDay = day.format(end);
        const startMonth = month.format(start).replace('.', '');
        const endMonth = month.format(end).replace('.', '');
        const joiner = '\u2060';
        target.textContent = `${startDay}${joiner}. de ${startMonth} y ${endDay}${joiner}. de ${endMonth}.`;
      }
    }
  });
}

(() => {
  const syncProductCtas = () => {
    document.querySelectorAll('button[id^="ProductSubmitButton-"]').forEach((button) => {
      button.classList.add('ar-product-cta');
      const label = button.querySelector(':scope > span:first-child');
      if (!label) return;
      const unavailable = /agotado|no disponible|unavailable|sold out/i.test(label.textContent || '');
      if (!unavailable) label.textContent = 'Agregar al carrito';
    });
  };

  let syncFrame;
  const scheduleSync = () => {
    cancelAnimationFrame(syncFrame);
    syncFrame = requestAnimationFrame(syncProductCtas);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled']
  });
})();


if (!customElements.get('arome-product-shipping-progress')) {
  customElements.define('arome-product-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold) * 100;
      this.message = this.querySelector('[data-shipping-message]');
      this.fill = this.querySelector('[data-shipping-fill]');
      this.truck = this.querySelector('[data-shipping-truck]');
      this.track = this.querySelector('[role="progressbar"]');
      this.hint = this.querySelector('[data-shipping-hint]');
      if (!(this.threshold > 0) || !this.message || !this.fill || !this.track) return;

      this.refresh = this.refresh.bind(this);
      this.unsubscribe = typeof subscribe === 'function'
        ? subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh)
        : null;
      this.onCartState = (event) => {
        if (event?.detail?.cart) this.render(event.detail.cart);
      };
      document.addEventListener('arome:cart-state', this.onCartState);
      window.addEventListener('pageshow', this.refresh);
      this.refresh();
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      document.removeEventListener('arome:cart-state', this.onCartState);
      window.removeEventListener('pageshow', this.refresh);
      this.controller?.abort();
    }

    async refresh() {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          credentials: 'same-origin',
          cache: 'no-store',
          signal: controller.signal,
        });
        if (!response.ok) throw new Error('Cart request failed');
        const cart = await response.json();
        if (!controller.signal.aborted && this.isConnected) this.render(cart);
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (this.message) this.message.textContent = 'Tu progreso de envío gratis se actualizará al agregar al carrito.';
      }
    }

    render(cart) {
      if (!Number.isFinite(cart?.total_price) || cart.total_price < 0) return;
      if (cart.currency && cart.currency !== 'MXN') {
        this.message.textContent = 'Envío gratis disponible para compras en México.';
        this.fill.style.width = '0%';
        if (this.truck) this.truck.style.left = '0%';
        this.track.setAttribute('aria-valuenow', '0');
        return;
      }

      const total = cart.total_price;
      const remaining = Math.max(0, this.threshold - total);
      const progress = Math.min(100, (total / this.threshold) * 100);
      const amount = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: remaining % 100 === 0 ? 0 : 2,
      }).format(remaining / 100);

      this.fill.style.width = `${progress}%`;
      if (this.truck) this.truck.style.left = `${Math.min(Math.max(progress, 3), 96)}%`;
      this.track.setAttribute('aria-valuenow', String(Math.round(progress)));

      if (remaining === 0) {
        this.classList.add('is-complete');
        this.message.innerHTML = '<strong>¡Envío gratis desbloqueado!</strong>';
        if (this.hint) this.hint.textContent = 'Tu pedido ya alcanza el envío gratis a todo México.';
      } else {
        this.classList.remove('is-complete');
        this.message.innerHTML = `Te faltan <strong>${amount}</strong> para envío gratis`;
        if (this.hint) this.hint.textContent = progress >= 60
          ? '¡Ya casi! Agrega otro favorito y aprovecha el envío gratis.'
          : 'Agrega tus favoritos y desbloquea el envío gratis.';
      }
    }
  });
}

/* ARÔME mobile sticky purchase reminder */
(() => {
  const initStickyBuy = () => {
    document.querySelectorAll('product-info[id^="MainProduct"]').forEach((root) => {
      if (root.dataset.arStickyBound === 'true') return;
      const mainButton = root.querySelector('button[id^="ProductSubmitButton-"]');
      const sticky = root.querySelector('[data-ar-sticky-buy]');
      const change = sticky?.querySelector('[data-ar-sticky-change]');
      const action = sticky?.querySelector('[data-ar-sticky-action]');
      const variantText = sticky?.querySelector('[data-ar-sticky-variant]');
      const priceText = sticky?.querySelector('[data-ar-sticky-price]');
      const picker = root.querySelector('variant-selects, variant-radios, [id^="variant-selects-"]');
      if (!mainButton || !sticky || !action) return;
      root.dataset.arStickyBound = 'true';

      const money = new Intl.NumberFormat('es-MX', { style:'currency', currency:'MXN', minimumFractionDigits:0, maximumFractionDigits:2 });
      const scrollToPicker = () => {
        const target = picker || root.querySelector('.product-form__input');
        if (!target) return;
        const y = target.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo({ top:y, behavior:'smooth' });
      };
      const sync = () => {
        const checked = root.querySelector('.product-form__input input[type="radio"]:checked');
        if (variantText) {
          let size = '';
          if (checked) {
            const raw = (checked.value || '').trim();
            const match = raw.match(/\b\d+\s*ml\b/i);
            size = match ? match[0].replace(/\s+/g, ' ') : raw.split(/[|\/]/)[0].trim();
          }
          if (!size) {
            const raw = variantText.textContent || '';
            const match = raw.match(/\b\d+\s*ml\b/i);
            size = match ? match[0].replace(/\s+/g, ' ') : '30 ml';
          }
          variantText.textContent = size;
        }
        const price = root.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale, [id^="price-"] .price-item');
        if (priceText && price) priceText.textContent = price.textContent.trim();
      };
      const setVisible = (visible) => {
        sticky.hidden = !visible;
        sticky.setAttribute('aria-hidden', String(!visible));
        document.body.classList.toggle('ar-sticky-buy-visible', visible);
      };
      const observer = new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        setVisible(passed && window.matchMedia('(max-width: 749px)').matches);
      }, { threshold:0 });
      observer.observe(mainButton);
      change?.addEventListener('click', scrollToPicker);
      action.addEventListener('click', () => {
        if (mainButton.disabled) { scrollToPicker(); return; }
        mainButton.click();
      });
      root.addEventListener('change', () => setTimeout(sync, 120));
      window.addEventListener('resize', () => {
        if (!window.matchMedia('(max-width: 749px)').matches) setVisible(false);
      });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStickyBuy, {once:true});
  else initStickyBuy();
})();
